import { AgGridPivotTableVisual } from 'src/app/pbir/visuals/agGrid/pivotTable/PivotTableVisual.component';
import { AgGridTableVisual } from 'src/app/pbir/visuals/agGrid/table/TableVisual.component';
import { VisualChartType } from '../chart-type';
import { PbiDataRoles, VisualChartRoleCategorisation } from '../data-role';
import { SortingGroups } from '../sorting-groups';

export const TablelikeChartTypes = {
  pivotTable: <VisualChartType<AgGridPivotTableVisual.Options>>{
    name: 'pivotTable',
    alias: 'pivotTable',
    dataRoles: {
      rows: PbiDataRoles.pivotTableRows,
      columns: PbiDataRoles.pivotTableColumns,
      values: PbiDataRoles.pivotTableMeasures,
    },
    title: 'Pivot Table',
    icon: 'far fa-table',
    previewImageUrl: '/assets/img/icons/chart-pivot-table-solid.svg',
    previewWhiteImageUrl: '/assets/img/icons-white/chart-pivot-table-solid.svg',
    previewRedImageUrl: '/assets/img/icons-red/chart-pivot-table-solid.svg',
    previewGreyImageUrl: '/assets/img/icons-grey/chart-pivot-table-solid.svg',

    defaultDataRoles: {
      measuresDataRole: PbiDataRoles.pivotTableMeasures.name,
      fallbackDataRole: PbiDataRoles.pivotTableRows.name
    },

    getDataRoleOptions: (params) => ({
      rows: {
        fieldCountForScroll: 6
      },
      columns: {
        fieldCountForScroll: 3
      },
      values: {
        fieldCountForScroll: 6
      }
    }),

    roleCategorisation: VisualChartRoleCategorisation.Categorised,

    sortingGroups: [SortingGroups.pivotTableColumns],

    
    visualType: AgGridPivotTableVisual.type,
    visualTypeOptions: {
      visualOptions: {
        ...AgGridPivotTableVisual.type.visualOptions,
      }
    },
  },

  table: <VisualChartType<AgGridTableVisual.Options>>{
    name: 'table',
    alias: 'table',
    dataRoles: {
      rows: null,
      columns: null,
      values: PbiDataRoles.tableFields
    },
    title: 'Table',
    icon: 'far fa-table',
    previewImageUrl: '/assets/img/icons/chart-table-solid.svg',
    previewWhiteImageUrl: '/assets/img/icons-white/chart-table-solid.svg',
    previewRedImageUrl: '/assets/img/icons-red/chart-table-solid.svg',
    previewGreyImageUrl: '/assets/img/icons-grey/chart-table-solid.svg',

    defaultDataRoles: {
      fallbackDataRole: PbiDataRoles.tableFields.name
    },

    getDataRoleOptions: (params) => ({
      values: {
        fieldCountForScroll: 20
      }
    }),

    roleCategorisation: VisualChartRoleCategorisation.Uncategorised,

    // INFO: IN-3552 - on table visuals, measure fields must be summarised
    disallowMeasuresWithDoNotSummarize: true,

    sortingGroups: [SortingGroups.tableColumns],

    visualType: AgGridTableVisual.type,
    visualTypeOptions: {
      visualOptions: {
        ...AgGridTableVisual.type.visualOptions,
      }
    },
  },
};
